class Models{
    id;
    modelname;
    seriname;
    environment;
    useType;
    testType;
    countdevice;
    sensore;
    constructor(id,modelname,seriname,environment,useType,testType,countdevice,sensore){
        this.id=id;
        this.modelname=modelname;
        this.seriname=seriname;
        this.environment=environment;
        this.useType=useType;
        this.testType=testType;
        this.countdevice=countdevice;
        this.sensore=sensore
    }
    getId(){
        return this.id;
    };

}
export{Models}